import { calculateLocale } from "@pandas/core-ui";
import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import CardButton from "@/components/CardButton";
import useNavigationHelpers from "@/hooks/useNavigationHelpers";
import { useStore } from "@/store";
import { getPricingUrl } from "@/utils/urlHelpers";

export const Route = createFileRoute("/$locale/$partner/_app/_card/quote-vs-estimate")({
	component: QuoteVsEstimate,
});

function QuoteVsEstimate() {
	const { i18n, t } = useTranslation();
	const { goToNextStep } = useNavigationHelpers();
	const sessionId = useStore((state) => state.sessionId) as string;
	const configId = useStore((state) => state.configId) as string;
	const locale = calculateLocale(i18n.language, undefined);
	const pricingUrl = getPricingUrl(locale, configId, sessionId);

	const options = {
		"get-voucher": {
			title: "Evaluate now and secure a final quote",
			subtitle: "Run an AI evaluation to lock your final quote instantly.",
			onClick: () => goToNextStep(),
		},
		"get-estimate": {
			title: "Get an estimate",
			subtitle: "Get a quick ballpark price estimate for your device.",
			onClick: () => window.location.replace(pricingUrl),
		},
	};

	return (
		<div className="flex flex-col h-full items-center">
			<h3 className="whitespace-pre-line text-center pt-10 lg:pt-20">{t("instructions.What would you like to do?")}</h3>
			<div className="h-full flex flex-col justify-around overflow-y-auto">
				<div className="w-full h-[288px] sm:h-[360px] relative max-h-[40dvh] my-4">
					<img
						src={`/images/quote-vs-estimate.png`}
						alt="flow-selection"
						className="w-full h-full object-contain"
					/>
				</div>
				<div className="max-w-[600px]">
					{Object.entries(options).map(([key, { title, subtitle, onClick }]) => (
						<CardButton
							key={key}
							iconKey={key}
							title={t(`btn.${title}`)}
							subtitle={t(`btn.${subtitle}`)}
							onClick={onClick}
						/>
					))}
				</div>
			</div>
		</div>
	);
}
